// Сортировка
export default function fSortArray(arr: Array<any>, type: number) {
    // По Алфавиту по возрастанию
    return arr.sort((a, b) => {
        let codeField = '';
        if (a.name) {
            codeField = 'name';
        }
        if (a.code) {
            codeField = 'code';
        }

        const nameA = a[codeField].toUpperCase(); // ignore upper and lowercase
        const nameB = b[codeField].toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
    });
    // if (type === 1) {
    //     // По дате по убыванию
    //     return arr.sort((a, b) => {
    //         const nameA = a.created;
    //         const nameB = b.created;
    //         if (nameA > nameB) {
    //             return -1;
    //         }
    //         if (nameA < nameB) {
    //             return 1;
    //         }
    //         // names must be equal
    //         return 0;
    //     });
    // }
    // if (type === 2) {
    //     // По дате по возрастанию
    //     return arr.sort((a, b) => {
    //         const nameA = a.created;
    //         const nameB = b.created;
    //         if (nameA < nameB) {
    //             return -1;
    //         }
    //         if (nameA > nameB) {
    //             return 1;
    //         }
    //         // names must be equal
    //         return 0;
    //     });
    // }
    // if (type === 3) {
    //     // По Алфавиту по возрастанию
    //     return arr.sort((a, b) => {
    //         const nameA = a.name.toUpperCase(); // ignore upper and lowercase
    //         const nameB = b.name.toUpperCase(); // ignore upper and lowercase
    //         if (nameA < nameB) {
    //             return -1;
    //         }
    //         if (nameA > nameB) {
    //             return 1;
    //         }
    //         // names must be equal
    //         return 0;
    //     });
    // }
    // if (type === 4) {
    //     // По Алфавиту по убыванию
    //     return arr.sort((a, b) => {
    //         const nameA = a.name.toUpperCase(); // ignore upper and lowercase
    //         const nameB = b.name.toUpperCase(); // ignore upper and lowercase
    //         if (nameA > nameB) {
    //             return -1;
    //         }
    //         if (nameA < nameB) {
    //             return 1;
    //         }
    //         // names must be equal
    //         return 0;
    //     });
    // }
    return arr;
}
